import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CloseIcon from "@material-ui/icons/Close";
import RefreshIcon from "@material-ui/icons/Refresh";

import _ from "lodash";
import { getEntitiesArray } from "../../../reducers/entitiesReducer";
import {
  successColor,
  dangerColor,
} from "../../../assets/jss/material-dashboard-pro-react";
import DefaultTable from "../../general/conf-table/ConfTable";
import assetSpreadsheetActions from "../../../actions/assetSpreadsheetActions";
import assetSpreadsheetTableColumns from "./assetSpreadsheetTableColumns";
import notificationActions from "../../general/notification/NotificationsManager/actions";
import popupActions from "../../general/popup/PopupsManager/actions";
import cacheActions from "../../../actions/cacheActions";

class AssetSpreadsheetsTable extends Component {
  state = {
    id: `${Math.random()}`,
  };

  operations = [
    // {
    //   title: 'Excluir',
    //   content: <CloseIcon fontSize="small" nativeColor={dangerColor} />,
    //   execute: row => this.onRowDelete(row.id),
    // },
    // {
    //   title: 'Reimportar',
    //   content: <RefreshIcon nativeColor={successColor} />,
    //   execute: row => this.onRowReimport(row.id),
    // },
  ];

  componentWillMount() {
    this.onMount();
  }

  fetchAssetSpreadsheets = () =>
    this.props.dispatch(assetSpreadsheetActions.fetchAll());

  reimportAssetSpreadsheet = (id) =>
    this.props.dispatch(assetSpreadsheetActions.reimport(id));

  deleteAssetSpreadsheet = (id) =>
    this.props.dispatch(assetSpreadsheetActions.delete(id));

  onMount = () => {
    this.props.dispatch(cacheActions.cleanCache());
    this.fetchAssetSpreadsheets().catch(this.onOperationFail);
  };

  onRowReimport = (id) => {
    this.reimportAssetSpreadsheet(id)
      .then(this.onReimportSucceed)
      .catch(this.onOperationFail);
  };

  onRowDelete = (id) => {
    this.deleteAssetSpreadsheet(id)
      .then(this.onDeleteSucceed)
      .catch(this.onOperationFail);
  };

  onOperationFail = (apiResponse) =>
    this.props.dispatch(popupActions.handleApiResponse(apiResponse));

  onReimportSucceed = () => {
    const { dispatch } = this.props;
    const message = "A planilha foi reimportada com sucesso.";
    dispatch(notificationActions.showSuccessNotification(message));
  };

  onDeleteSucceed = () => {
    const { dispatch } = this.props;
    const message = "A planilha foi excluída com sucesso.";
    dispatch(notificationActions.showSuccessNotification(message));
  };

  render() {
    let { assetSpreadsheets } = this.props;
    assetSpreadsheets = _.sortBy(assetSpreadsheets, "id").reverse();
    const { id } = this.state;
    return (
      <DefaultTable
        id={id}
        columns={assetSpreadsheetTableColumns}
        dataList={assetSpreadsheets}
        operations={this.operations}
      />
    );
  }
}

AssetSpreadsheetsTable.propTypes = {
  dispatch: PropTypes.func.isRequired,
  assetSpreadsheets: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  assetSpreadsheets: getEntitiesArray("assetSpreadsheets")(state),
});

export default connect(mapStateToProps)(AssetSpreadsheetsTable);
